export default "__VITE_ASSET__DjUjqq4x__"